<div class="main_content">

  <div class="first_text">
    <p>Complete all steps to create a new taxonomy string.</p>
  </div>

  <div class="white_cart_box"
       *ngFor="let t of taxonomies; index as i">

    <div class="tabs_list"
         [class.no_edit]="!t.isInSelectMode">

      <div class="tab_item">
        <input type="checkbox"
               [id]="'tab' + i"
               [(ngModel)]="t.isClientsChecked"
               (change)="t.onCheckedChanged('clients')" />
        <label [for]="'tab' + i">
          <span>Client</span>
          <span class="select">{{t.selectedClient?.name}}</span>
        </label>

        <div [id]="'tab-content' + i"
             class="content"
             *ngIf="t.isInSelectMode">
          <div class="loader"
               *ngIf="t.isClientsLoading$ | async">
            <span class="loader-icon"></span>
            <span class="loader-text">Loading client list</span>
          </div>

          <div class="add_to_sheet"
               *ngIf="t.clientsError">
            <button [disabled]="isInProcess"
                    (click)="t.loadClients()">
              <span>TRY AGAIN</span>
            </button>
          </div>
          <div class="error"
               *ngIf="t.clientsError">
            <span>Error: {{t.clientsError}}</span>
          </div>

          <div class="warning"
               *ngIf="t.clients && t.clients.length === 0">
            <span>Warning: There are no clients.</span>
          </div>

          <div class="select_text"
               *ngIf="t.clients && t.clients.length > 0">
            <p>Select a client</p>
          </div>
          <div class="wraper_ul"
               *ngIf="t.clients && t.clients.length > 0">
            <ul>
              <li *ngFor="let client of t.clients"
                  [class.active]="client == t.selectedClient">
                <button (click)="t.onClientSelected(client)">
                  <span>{{client.name}}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="tab_item"
           *ngIf="t.selectedClient">
        <input type="checkbox"
               [id]="'tab2' + i"
               [(ngModel)]="t.isTaxonomiesChecked"
               (change)="t.onCheckedChanged('taxonomies')" />
        <label [for]="'tab2' + i">
          <span>Taxonomy</span>
          <span class="select">{{t.selectedTaxonomy?.name}}</span>
        </label>

        <div [id]="'tab-content2' + i"
             class="content"
             *ngIf="t.isInSelectMode">
          <div class="loader"
               *ngIf="t.isTaxonomiesLoading$ | async">
            <span class="loader-icon"></span>
            <span class="loader-text">Loading taxonomy list</span>
          </div>

          <div class="add_to_sheet"
               *ngIf="t.taxonomiesError">
            <button [disabled]="isInProcess"
                    (click)="t.loadTaxonomies()">
              <span>TRY AGAIN</span>
            </button>
          </div>
          <div class="error"
               *ngIf="t.taxonomiesError">
            <span>Error: {{t.taxonomiesError}}</span>
          </div>

          <div class="warning"
               *ngIf="t.taxonomies && t.taxonomies.length === 0">
            <span>Warning: There are no taxonomies.</span>
          </div>

          <div class="select_text"
               *ngIf="t.taxonomies && t.taxonomies.length > 0">
            <p>Select a taxonomy</p>
          </div>
          <div class="wraper_ul"
               *ngIf="t.taxonomies && t.taxonomies.length > 0">
            <ul>
              <li *ngFor="let taxonomy of t.taxonomies"
                  [class.active]="taxonomy == t.selectedTaxonomy">
                <button (click)="t.onTaxonomySelected(taxonomy)">
                  <span>{{taxonomy.name}}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    <div class="add_to_sheet"
         *ngIf="!t.tableExists">
      <button [disabled]="!t.isReady || isInProcess"
              (click)="t.insertData()">
        <span>ADD TO SHEET</span>
      </button>
    </div>

    <div class="add_to_sheet"
         *ngIf="t.isReady && t.tableExists">
      <button [disabled]="isInProcess"
              (click)="t.submitValues()">
        <span>SUBMIT VALUES</span>
      </button>
    </div>

    <div class="loader"
         *ngIf="t.isLoading$ | async">
      <span class="loader-icon"></span>
      <span class="loader-text">{{t.currOperation}}</span>
    </div>

    <div class="error"
         *ngIf="t.error">
      <span>Error: {{t.error}}</span>
    </div>

    <div class="warning"
         *ngIf="t.fields && t.fields.length === 0">
      <span>Warning: There are no taxonomy fields.</span>
    </div>

  </div>

  <div class="add_another_taxonomy"
       *ngIf="canAddNew">
    <button [disabled]="isInProcess"
            (click)="addNew()">
      <span>ADD ANOTHER TAXONOMY</span>
    </button>
  </div>
